import _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../services/log.service';
import { environment } from '../../../../environments/environment';
import { AdminService } from '../../../services/admin.service';
import { HttpClient } from '../../../../../node_modules/@angular/common/http';
import { SessionStorageService } from '../../../services/session-storage.service';
import { HsApiService } from '../../../services/hs-api.service';
import { SessionService } from '../../../services/session.service';
import { AdminPreviewError } from '../../../types/admin/admin-preview-error';
import { AdminUser } from '../../../types/admin/admin-user';
import { ToasterService } from '../../../services/toaster.service';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-bulk-load-dialog',
  templateUrl: './bulk-load-dialog.component.html',
  styleUrls: ['./bulk-load-dialog.component.scss']
})
export class BulkLoadDialogComponent implements OnInit {
  private static FORM = 1;
  private static PREVIEW = 2;
  private static ERROR = 3;
  private file: File;
  private sendWelcome = false;
  private screen = BulkLoadDialogComponent.FORM;
  private users: AdminUser[];
  private errors: AdminPreviewError[];

  constructor(
    private log: LogService,
    public activeModal: NgbActiveModal,
    private admin: AdminService,
    private session: SessionService,
    private sessionStorage: SessionStorageService,
    private http: HttpClient,
    private hsApi: HsApiService,
    private toaster: ToasterService,
    private spinner: SpinnerService
  ) {}

  ngOnInit() {
    if (this.admin.isDevMode()) {
      this.onPreview();
    }
  }

  onSelect() {
    this.file = (<HTMLInputElement>document.getElementById('file')).files[0];
    this.log.trace('BulkLoadDialogComponent.onSelect.file', this.file);
  }

  onUserAction() {
    this.session.registerUserAction();
  }

  isErrorScreen(): boolean {
    return this.screen === BulkLoadDialogComponent.ERROR;
  }

  isFormScreen(): boolean {
    return this.screen === BulkLoadDialogComponent.FORM;
  }

  isPreviewScreen(): boolean {
    return this.screen === BulkLoadDialogComponent.PREVIEW;
  }

  gotoFormScreen() {
    this.screen = BulkLoadDialogComponent.FORM;
  }

  gotoPreviewScreen() {
    this.screen = BulkLoadDialogComponent.PREVIEW;
  }

  gotoErrorScreen() {
    this.screen = BulkLoadDialogComponent.ERROR;
  }

  onPreview() {
    this.spinner.showSpinner();
    this.admin.getBulkLoadPreview(
      this.sendWelcome,
      this.file,
      (users, errors) => {
        this.spinner.hideSpinner();
        if (errors && errors.length > 0) {
          this.errors = errors;
          this.log.trace(
            'BulkLoadDialogComponent.onPreview.errors',
            this.errors
          );
          this.screen = BulkLoadDialogComponent.ERROR;
        } else if (users && users.length > 0) {
          this.users = users;
          this.log.trace('BulkLoadDialogComponent.onPreview.users', this.users);
          this.screen = BulkLoadDialogComponent.PREVIEW;
        } else {
          this.toaster.showAlert(
            'File contains no data, please review and resubmit.'
          );
        }
      }
    );
  }

  onUpload() {
    this.spinner.showSpinner();
    this.admin.doBulkUpload(this.sendWelcome, this.file, () => {
      this.spinner.hideSpinner();
      this.log.trace('BulkLoadDialog.onUpload.success');
      this.activeModal.close();
      this.toaster.showInfoTimed('Users uploaded successfully');
    });
  }

  onResubmit() {
    this.file = null;
    this.screen = BulkLoadDialogComponent.FORM;
  }

  onClose() {
    this.log.trace('cancel');
    this.activeModal.dismiss();
  }

  isErrorsDetected(): boolean {
    return this.errors && this.errors.length > 0;
  }
}
